import { render, staticRenderFns } from "./JUserAvatar.vue?vue&type=template&id=4be3e6de"
import script from "./JUserAvatar.vue?vue&type=script&lang=ts"
export * from "./JUserAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports